import { useCallback, useState } from 'react';

const STORAGE_KEY = 'standards.recentSources.v1';

export interface RecentSource {
  id: string;
  title: string;
}

function readRecent(): RecentSource[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

/** Recently-opened sources (jurisdictions), persisted in localStorage for quick re-entry. */
export function useRecentSources(max = 6) {
  const [recent, setRecent] = useState<RecentSource[]>(readRecent);

  const recordSource = useCallback(
    (source: RecentSource) => {
      setRecent((prev) => {
        const next = [source, ...prev.filter((s) => s.id !== source.id)].slice(0, max);
        try {
          localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
        } catch {
          // ignore quota / disabled storage
        }
        return next;
      });
    },
    [max]
  );

  return { recent, recordSource };
}
